import axios from 'axios';
import API_HOST from '../api';

const api = {};

api.readProductEvent = (
  productEventId,
  clientId,
  userId,
) => {
  const url = `${API_HOST}/api/client/${clientId}/user/${userId}/read/product-event/${productEventId}`;

  return axios.post(url)
    .then(response => response.data);
};

api.getProductDetails = (productEvent) => {
  const url = productEvent.content.productDetailsUrl;

  return axios.get(url);
};

api.getClientProducts = (clientId) => {
  const url = `${API_HOST}/api/client/${clientId}/product-list?order=asc&sort=id`;
  const config = {
    params: {
      order: 'asc',
      sort: 'id',
    },
  };

  return axios.get(url, config)
    .then(response => response.data.productList, () => {
      alert('There was an error requesting your list of products');
    });
};

api.getUsersProductGroup = (clientId, roleId) => {
  const url = `${API_HOST}/api/client/${clientId}/role/${roleId}`;

  return axios.get(url)
    .then(response => response.data, () => {
      alert('There was an error requesting your list of products');
    });
};

api.getProductEvent = (productEventId, clientId, userId, inContextSwitch) => {
  let url = `${API_HOST}/api/client/${clientId}/user/${userId}/product-event/${productEventId}`;

  if (inContextSwitch) {
    url = `${API_HOST}/api/client/${clientId}/product-event/${productEventId}`;
  }

  return axios.get(url);
};

api.getProductList = (clientId, userId, sinceEpoch, inContextSwitch) => {
  let url = '';
  if (inContextSwitch) {
    url = `${API_HOST}/api/client/${clientId}/product-event-list`;
  } else {
    url = `${API_HOST}/api/client/${clientId}/user/${userId}/product-event-list`;
  }

  const config = {
    params: {
      'since-epoch': sinceEpoch,
    },
  };

  return axios.get(url, config);
};

export default api;
